<template>
  <div v-if="currentConsentObj">
    <ConsentEducation v-if="currentConsentType == 'education'" @updateConsentScreen="updateConsentScreen" :currentConsent="currentConsentObj" :page="educationPage" :lang="lang" @pageChange="page => (educationPage = page)" @updateHeaderNav="updateHeaderNav" :isOnBackClick="isOnBackClick"></ConsentEducation>
    <ConsentQuestions v-if="currentConsentType == 'questions'" @wrongAnswer="onWrongAnswer" @updateConsentScreen="updateConsentScreen" @updateHeaderNav="updateHeaderNav" @backButtonClick="gotoEducationLastPage" :currentConsent="consent.currentConsentObj" :page="questionPage" :lang="lang" @pageChange="page => (questionPage = page)" :isOnBackClick="isOnBackClick"></ConsentQuestions>
    <ConsentDisclaimer v-if="currentConsentType == 'disclaimer'" @backButtonClick="gotoQuestionsLastPage" @updateConsentScreen="updateConsentScreen" @updateHeaderNav="updateHeaderNav" @onConsentDisclaimer="onConsentDisclaimer"  @onDeclineConsent="onSignature" :currentConsent="consent.currentConsentObj" :isOnBackClick="isOnBackClick" :lang="lang"></ConsentDisclaimer>
    <ConsentSign
      v-if="currentConsentType == 'signature'"
      @backButtonClick="gotoQuestionsLastPage"
      @consentCompleted="updateConsentScreen"
      @updateConsentScreen="updateConsentScreen"
      @onSignature="onSignature"
      @updateHeaderNav="updateHeaderNav"
      :currentConsent="consent.currentConsentObj"
      :isOnBackClick="isOnBackClick"
      :consentSignatureAndDisclaimer="consentSignatureAndDisclaimer"
      :eConsentDetails="eConsentDetails"
      :lang="lang"
    ></ConsentSign>
  </div>
  <div v-else>
    <loader></loader>
    <vue-progress-bar class="progress_bar_header"></vue-progress-bar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Consent, Bitrise, Widget, ParticipantPortal } from "@/components/services/participant-service";
import ConsentEducation from "@/components/participant-portal/auth/join/consent-education";
import ConsentQuestions from "@/components/participant-portal/auth/join/consent-questions";
import ConsentDisclaimer from "@/components/participant-portal/auth/join/consent-disclaimer";
import ConsentSign from "@/components/participant-portal/auth/join/consent-sign";
import loader from "@/components/common/loader";
import { cloneDeep } from "lodash";

export default {
  name: "join-consent",
  components: {
    ConsentEducation,
    ConsentQuestions,
    ConsentDisclaimer,
    ConsentSign,
    loader
  },
  props: ["isOnBackClick", "selectedCohort", "lang", "consentSignatureAndDisclaimer", "consentScreen", "consentIndex", "listOfCohorts", "isDatavantTokenizationEnabled"],
  data() {
    return {
      widget: new Widget(),
      portal: new ParticipantPortal(),
      consent: new Consent(),
      bitrise: new Bitrise(),
      isParticipantAgreed: false,
      eConsentDetails: [],
      currentConsent: null,
      currentConsentObj: null,
      currentConsentType: this.consentScreen,
      currentConObj: 0,
      consentDisclaimer: [],
      currentConObjIndex: this.consentIndex,
      educationPage: 0,
      questionPage: 0,
      datavantConsentDetails: null
    };
  },
  computed: {
    ...mapGetters(["participant"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    }
  },
  watch: {
    consentScreen(val) {
      if (val == "education") {
        this.questionPage = 0;
        this.educationPage = 0;
        this.currentConsentType = val;
      }
      this.setBase64InitialAction(null);
    },
    consentIndex(val) {
      this.currentConObjIndex = val;
      this.walkThroughConcents();
    }
  },
   mounted() {
    let defaultCountry = this.portal.getDefaultCountryIso2();
    if (this.isDatavantTokenizationEnabled && defaultCountry != "" && defaultCountry.toLowerCase() == "us") {
      this.consent.getDataventConsentData().then(response => {
        this.datavantConsentDetails = response;
        this.datavantConsentDetails.datavantConsentMeta[0].dataVantConsent = true;
        this.getEducationConsent();
      });
    } else {
      this.getEducationConsent();
    }
    
    this.$root.$emit(
      "SetAfterCancelClosedScreen",
      this.listOfCohorts.length > 1 ? "isCohortCompleted" : "isDetailsCorrect"
    );
    this.updateConsentScreen(this.consentScreen); 
  },
  methods: {
    ...mapActions(["setBase64InitialAction", "setParticipantsPortalConsentData"]), 
    onWrongAnswer() {
      this.educationPage = 0;
      this.questionPage = 0;
      this.currentConsentType = "education";    
    },
    gotoQuestionsLastPage() {
      this.questionPage = this.currentConsentObj.details.quiz.questions.length - 1;
      this.currentConsentType = this.resolveScreenType("questions");
    },
    gotoEducationLastPage() {
      this.educationPage = this.currentConsentObj.details.sections.length - 1;
      this.currentConsentType = "education";
    },
    agreed() {
      this.isParticipantAgreed = true;
      this.$emit("updateHeaderNav", {
        showBlankHeader: true,
        title: this.currentConsentObj.config.consentName
      });
    },
    onConsentDisclaimer(disclamer) {
      this.consentDisclaimer = disclamer;
    },
    onSignature(signatureData) {
      const listOfsignatureAndDisclamer = {
        consentDisclaimer: this.consentDisclaimer,
        ...signatureData
      };
      this.consentSignatureAndDisclaimer.push(listOfsignatureAndDisclamer);
    },
    resolveScreenType(typeOld) {
      let type = typeOld;
      if(!this.currentConsent){
        return type
      }
      if (type === "education" && !this.currentConsent.educationEnabled) {
        type = "disclaimer";
      }
      if (type === "questions" && !this.currentConsent.comprehensionEnabled) {
        type = "disclaimer";
      }
      if (type === "disclaimer" && !this.currentConsent.documentAndSignatureEnabled) {
        type = "signature";
      }
      if (type === "signature" && !this.currentConsent.digitalSignatureEnabled) {
        type = "isConcentSignCompleted";
      }
      return type;
    },
    updateConsentScreen(typeParam) {
      const type = this.resolveScreenType(typeParam);
      if (type == "isReadyToJoinStudy") {
        this.$emit("updateActiveScreen", "start");
      }
      if (type == "prev-consent") {
        this.questionPage = 0;
        this.educationPage = 0;
        if (this.currentConObjIndex === 0) {
          if (this.listOfCohorts && this.listOfCohorts.length > 1) {
            this.$emit("updateActiveScreen", "isCohortCompleted");
          } else {
            this.$emit("updateActiveScreen", "isActivationCodeVerified");
          }
        } else {
          this.currentConObjIndex = this.currentConObjIndex - 1;
          this.$store.dispatch("setParticipantsPortalConsentData", this.eConsentDetails[this.currentConObjIndex]);
          this.updateConsentScreen("education");
          this.walkThroughConcents();
          this.getEducationConsent();
          this.$emit("updateActiveScreen", "isDetailsCorrect");
        }
      } else if (type == "isConcentSignCompleted") {
        this.questionPage = 0;
        this.educationPage = 0;
        if (this.currentConObjIndex < this.eConsentDetails.length - 1) {
          this.currentConObjIndex = this.currentConObjIndex + 1;
          this.walkThroughConcents();
          this.updateConsentScreen("education");
        } else {
          this.$emit("updateActiveScreen", "isConcentSignCompleted");
        }
      } else {
        this.currentConsentType = type;
        if (type == "isConcentSignCompleted") {
          this.$emit("updateActiveScreen", "isConcentSignCompleted");
        }
      }
      this.$emit("consentChanged", this.currentConObjIndex);
      this.$emit("updatedConsentScreen", this.currentConsentType);
    },
    updateHeaderNav(options) {
      this.$emit("updateHeaderNav", options);
    },
    updateActiveScreen() {
      this.$emit("updateActiveScreen", "isConcentEducationCompleted");
    },
    getEducationConsent() {
      if (this.selectedCohort != null) {        
        this.eConsentDetails = cloneDeep(this.selectedCohort.associatedConsent);
        if(this.datavantConsentDetails) {
          this.$set(this.eConsentDetails, this.selectedCohort.associatedConsent.length, this.datavantConsentDetails.datavantConsentMeta[0]);   
        }     
        this.walkThroughConcents();
      } else {
        this.eConsentDetails =
          this.listOfCohorts && this.listOfCohorts[0].associatedConsent;
          if(this.datavantConsentDetails) {
          this.$set(this.eConsentDetails, this.listOfCohorts[0].associatedConsent.length, this.datavantConsentDetails.datavantConsentMeta[0]);   
        } 
        this.walkThroughConcents();
      }
    },
    walkThroughConcents() {  
      this.currentConsent = this.eConsentDetails[this.currentConObjIndex];
      if (this.currentConsent.dataVantConsent) {
        this.currentConsentObj = { config: this.currentConsent, details: this.datavantConsentDetails.datavantConsentData[0] };
        let consentName = this.widget.i18nActivities("datavant_consent_form_title", this.lang);
        this.$store.dispatch("setParticipantsPortalConsentData", this.currentConsentObj);
        this.$root.$emit("setHeaderOptions", { title: consentName ? consentName : this.currentConsent.consentName });
      } else {
        this.consent.getConcentDetails(this.currentConsent).then((res) => {
          this.currentConsentObj = res;
          let consentName = this.widget.i18nActivities(res.config.consentId + "_consentName", this.lang);
          this.$store.dispatch("setParticipantsPortalConsentData", res);
          this.$root.$emit("setHeaderOptions", { title: consentName ? consentName : res.config.consentName });
        });
      }  
    }
  },
};
</script>
